<template>
  <div v-loading="loading">
    <el-tabs size="small" v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="错题排行榜" name="ranking"></el-tab-pane>
      <el-tab-pane label="易错题排行榜" name="show"></el-tab-pane>
    </el-tabs>

    <!--基础设置-->
    <Ranking v-if="activeName == 'ranking'"></Ranking>
    <Show v-if="activeName == 'show'"></Show>

  </div>
</template>
<script>
import Ranking from './part/Ranking';
import Show from './part/Show';
export default {
  components: {
    Ranking,
    Show
  },
  data() {
    return {
      /*是否加载完成*/
      loading: false,
      activeName: 'ranking',
    };
  },
  created() {
    // 默认
    let tabs = this.$db.getRouteField(this, 'tabs');
    if (tabs) this.activeName = tabs;

    if (this.$route.query.type != null) {
      this.activeName = this.$route.query.type;
    }
  },
  methods: {
    /*切换*/
    handleClick(e) {
      this.activeName = e.name;
      this.$db.setRoute(this, {'tabs': e.name});
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/study/questionerrorranking/index.vue